import { connect } from 'react-redux';
import type { QuoteFormError } from 'state/addonForm/addonForm.selector';
import { getDynamicFormInfos } from 'state/selectors/common/dynamicForm';
import type { AppState } from 'state/state.model';

export interface OwnProps {
  tabId: string;
}

export interface StateProps {
  validationErrors: readonly QuoteFormError[];
  hiddenFields: readonly string[];
}

export type ValidationErrorsState = StateProps & OwnProps;
const emptyArray: readonly [] = [];

const mapStateToProps = (state: AppState, { tabId }: OwnProps): StateProps => {
  return {
    validationErrors: getDynamicFormInfos(state, tabId)?.validationErrors ?? emptyArray,
    hiddenFields: emptyArray,
  };
};

export const connectValidationErrors = connect(mapStateToProps);
